import React, { useRef } from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";
import * as yup from "yup";

import * as commonFunc from 'scripts/common';

import {
    Input, Button,
    Label,
    FormGroup, FormFeedback,
    InputGroup, InputGroupText, Col
} from "reactstrap";


export default function CanvasFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, setValue, resetField, errors } = formManager;

    const canvasRef = useRef(null);

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.defaultValue) {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            const img = new Image();
            img.onload = () => { ctx.drawImage(img, 0, 0); };
            img.src = `data:image/png;base64,${data.defaultValue}`;
        }

        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    console.debug("RESPONSE");
                    console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };

    const { ref: refElem, ...restElem } = register(bindPropResult);

    var disabled = (isConfiguration ? true : ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false)));

    var btnClass = "m-1";
    var btnSupClass = "";
    var btnStyle = { };
    var altStyle = {};
    var frameClass = "";
    var frameStyle = {};
    var titleWidthClass = "";
    var titleWidthStyle = {};
    var iconsStyle = { color: "#888888", fontSize: "20px" };
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }
    if (commonFunc.isBlank(data.title) && (data.children == null || data.children.length <= 1)) btnSupClass += " btn-icon ";

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_canvas");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            btnClass += supBoxSize;
        }

        if (design.height) btnStyle.height = design.height;
        if (design.width) btnStyle.width = design.width;

        if (design.margin) {
            btnStyle.margin = design.margin;
            btnClass = btnClass.replace("m-1", "");
        }
        if (design.marginTop) {
            if (design.marginTop.indexOf("px") >= 0) {
                btnStyle.marginTop = design.marginTop;
            }
            else {
                btnSupClass += design.marginTop;
            }
        }

        //if (design.fontColor) btnStyle.color = modelFctManager.getRgbaFromHex(design.fontColor);
        //if (designIcon.fontSize) btnStyle.fontSize = design.fontSize;
        Object.assign(btnStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(altStyle, modelFctManager.setCustomBackground(design, data));
    }
    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_canvasTitle", true);
    if (designTitle) {
        if (designTitle.fontColor) titleWidthStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleWidthStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleWidthStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleWidthStyle.fontStyle = "italic";
        }

        if (designTitle.alignment) {
            var split = designTitle.alignment.split("|");
            split.forEach((part) => {
                titleWidthClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleWidthClass = titleWidthClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
    }
    var designIcon = data.customDesign?.designIcon;
    designIcon = modelFctManager.prepareMergedDesign(data, designIcon, "default_canvasIcon", true);
    if (designIcon) {
        if (designIcon.fontColor) iconsStyle.color = modelFctManager.getRgbaFromHex(designIcon.fontColor);
        if (designIcon.fontSize) iconsStyle.fontSize = designIcon.fontSize;
    }

    var baseForm = <div>
        <div className={titleWidthClass} style={titleWidthStyle}>{data.title}</div>
        <div className="d-flex">
            <canvas ref={canvasRef} className="" width="285" height="150" style={btnStyle}></canvas>
            <div className={`d-flex flex-column align-items-center p-3 ${disabled ? "d-none" : ""}`} style={altStyle}>
                <div className="align-content-center" style={{ flex: 1, ...iconsStyle }}><i className="fa fa-eraser"></i></div>
                <div className="align-content-center" style={{ flex: 1, ...iconsStyle }}><i className="fa fa-lock"></i></div>
            </div>
        </div>
    </div>;
    return <Col data-name="CanvasFrag" data-element={data.objType} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}